/* LunyMerch: Scroll-Bewegung für Kacheln, Regal, Bänder und Newsletter. Nutzt translate/rotate/scale, damit Theme-Animationen (transform) unberührt bleiben. */
(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var RISE='slider-element > * > *, .card-grid > *, .lm-finder__panel';
  var TILT='lookbook-element';
  var SWAY='[id*="scrolling-text-2"] .section, [id*="scrolling_text"] .section';
  var CARD='reveal-testimonials > *';
  var GROW='[id*="newsletter_home"] .section > *';
  var items=new Map(),active=new Set(),tick=false;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)active.add(e.target);else{active.delete(e.target);if(e.boundingClientRect.top<0)clear(e.target)}});ask()},{rootMargin:'25% 0px 25% 0px'});
  function clear(el){el.style.translate='';el.style.rotate='';el.style.scale='';el.style.opacity=''}
  function add(el,kind,i){if(items.has(el))return;if(el.closest('.lm-hero,.quick-view,cart-drawer,.drawer,slideshow-element'))return;items.set(el,{k:kind,i:i||0});io.observe(el)}
  function scan(){
    document.querySelectorAll(RISE).forEach(function(el){var n=[].indexOf.call(el.parentNode.children,el);add(el,'rise',n)});
    document.querySelectorAll(TILT).forEach(function(el){add(el,'tilt')});
    document.querySelectorAll(SWAY).forEach(function(el){add(el,'sway');var s=el.closest('.shopify-section');if(s){s.style.overflowX='clip'}});
    document.querySelectorAll(GROW).forEach(function(el){add(el,'grow')});
    document.querySelectorAll(CARD).forEach(function(el){add(el,'card',[].indexOf.call(el.parentNode.children,el))});
    ask();
  }
  function c(v){return v<0?0:v>1?1:v}
  function ease(v){return 1-Math.pow(1-v,3)}
  function paint(){
    tick=false;var vh=innerHeight,small=innerWidth<768;
    active.forEach(function(el){
      var it=items.get(el);if(!it)return;var r=el.getBoundingClientRect();
      if(it.k==='rise'){
        var cols=small?2:4,p=ease(c((vh*.98-r.top)/(vh*.42)-(it.i%cols)*.07)),q=1-p;
        if(r.right<0||r.left>innerWidth){clear(el);return}
        el.style.translate='0 '+(q*(small?28:48)).toFixed(1)+'px';el.style.rotate=(q*(it.i%2?-1.6:1.6)).toFixed(2)+'deg';el.style.opacity=(.3+.7*p).toFixed(3);
      }else if(it.k==='tilt'){
        var t=c((vh-r.top)/(vh+r.height));el.style.rotate=((.5-t)*(small?3:5)).toFixed(2)+'deg';el.style.scale=(.97+.03*ease(c(t*2))).toFixed(3);
      }else if(it.k==='sway'){
        var s=c((vh-r.top)/(vh+r.height));el.style.rotate=((s-.5)*(small?5:4)).toFixed(2)+'deg';el.style.scale='1.06';
      }else if(it.k==='card'){
        var d=(r.top+r.height/2-vh/2)/vh;el.style.rotate=(d*(it.i%2?-7:7)).toFixed(2)+'deg';
      }else if(it.k==='grow'){
        var g=ease(c((vh*.95-r.top)/(vh*.5)));el.style.scale=(.94+.06*g).toFixed(3);
      }
    });
  }
  function ask(){if(!tick){tick=true;requestAnimationFrame(paint)}}
  addEventListener('scroll',ask,{passive:true});addEventListener('resize',ask,{passive:true});
  document.addEventListener('lm:refresh',scan);
  var mo,wait;mo=new MutationObserver(function(){clearTimeout(wait);wait=setTimeout(scan,350)});
  function go(){scan();var m=document.querySelector('main');if(m)mo.observe(m,{childList:true,subtree:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
